import React, { useState } from 'react';

import { InputOption } from 'components/common/MyCustomSelect/components/InputOption/InputOption';
import { ValueContainer } from 'components/common/MyCustomSelect/components/ValueContainer/ValueContainer';

import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramCriticalAnalysis/programCriticalAnalysis.module.scss';
import { morefilterItems } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramCriticalAnalysis/utils';
import { Select } from 'components/DesignSystem/Select';
import { Switch } from 'components/DesignSystem/Switch';
import { TextInput } from 'components/DesignSystem/TextInput/TextInput';

export const statusOptions: ISelectOption<string>[] = [
    {
        value: 'TODO',
        label: 'To Do',
    },
    {
        value: 'IN_PROGRESS',
        label: 'In Progress',
    },
    {
        value: 'Done',
        label: 'Done',
    },
];

export const CriticalAnalysisDelayDriversFilter = ({
    handleOnSearch,
    dateFilter,
    handleDateFilter,
    months,
    handleStatusType,
    statusFilter,
    handleStatus,
    typeFilter,
    handleCriticalPath,
    isCriticalPath,
    handleDelayDriver,
    isDelayDriver,
}) => {
    const [searchText, setSearchText] = useState('');

    const handleSearchFilterSubmitted = () => {
        handleOnSearch(searchText);
    };

    const handleClear = () => {
        setSearchText('');
        handleOnSearch('');
    };

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.code === 'Enter' || e.code === 'NumpadEnter') {
            handleOnSearch(searchText);
        }
    };

    return (
        <div className={classes.filterWrapper}>
            <div className={classes.filterTextSearch}>
                <TextInput
                    label={'Name'}
                    placeholder={'Search Activities by Name'}
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    onClear={handleClear}
                    maxLength={200}
                    onKeyDown={onKeyDown}
                    className={classes.textInput}
                    searchable={true}
                    onSearch={handleSearchFilterSubmitted}
                />
            </div>

            <div className={classes.selectWrapper}>
                <Select<ISelectOption<string>>
                    value={dateFilter}
                    options={months}
                    onChange={handleDateFilter}
                    label={'Month'}
                />
            </div>
            <div className={classes.selectWrapper}>
                <Select<ISelectOption<string>, true>
                    id={'status-filter'}
                    value={statusFilter}
                    options={statusOptions}
                    onChange={handleStatusType}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    isMulti={true}
                    placeholder={'Select Status...'}
                    components={{
                        Option: InputOption,
                        ValueContainer: ValueContainer,
                    }}
                    label={'Status'}
                />
            </div>
            <div>
                <Switch
                    onChange={handleDelayDriver}
                    checked={isDelayDriver}
                    labelPlacement={'start'}
                    label={'Delay Driver'}
                />
            </div>
            <div>
                <Switch
                    onChange={handleCriticalPath}
                    checked={isCriticalPath}
                    label={'Critical Path Only'}
                    labelPlacement={'start'}
                />
            </div>
            <div className={classes.selectWrapper}>
                <Select<ISelectOption<string>, true>
                    label={'More Filters'}
                    value={typeFilter}
                    options={morefilterItems}
                    onChange={handleStatus}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    isMulti={true}
                    placeholder={'Select More Filters...'}
                    components={{
                        Option: InputOption,
                        ValueContainer: ValueContainer,
                    }}
                />
            </div>
        </div>
    );
};
